import * as React from 'react';
import cx from 'clsx';

import styles from './Banner.module.scss';
import GhostTile from '../GhostTile';

const Ghost: React.FC<{}> = () => (
  <div className={styles.container} data-testid="ghost-banner">
    <div className={cx(styles.file, styles.ghost)}>
      <GhostTile />
    </div>
  </div>
);

export default React.memo(Ghost);
